/* Product gallery behavior (slick sliders, image zoom, FBS price check,
   mobile DOM reorder) for the main product section.
   Moved out of main-product-v2.liquid. Depends on jQuery + slick (loaded in
   layout) and the jquery-zoom plugin (loaded just before this in the section).
   The current variant's featured media id is passed in via window.fcProductVariantMediaId. */


         $('.slick-prod-1').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            adaptiveHeight: true,
            infinite: true,
            arrows: false,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  asNavFor: '.slider-mobile'
                }
              }
            ]
          });

      let slider;
      if (document.querySelector('.slider_minum_4')) {
        slider = 4
      }else{
        slider = 6
      }

      $('.slider-mobile').slick({
        slidesToShow: slider,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        prevArrow:"<button type='button' class='slick-prev pull-left'><span class='arrow-left'></span></button>",
        nextArrow:"<button type='button' class='slick-next pull-right'><span class='arrow-right'></span></button>",
        asNavFor: '.slick-prod-1'
      });

      $(".slick-prod-1 .slick-slide").zoom({
        on: "click",
        onZoomIn: function(){
          $(this).addClass('zin');
        },
        onZoomOut: function(){
          $(this).removeClass('zin');
        }

      });

        // Slide Count
        var $status = $('.pagingInfo');
        var $slickElement = $('.slick-prod-1');

        $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
          //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          var i = (currentSlide ? currentSlide : 0) + 1;
          $status.text(i + '/' + slick.slideCount);
        });

      // Onload variant select
      var current_varID = window.fcProductVariantMediaId || '';
      updateCustomSlider(current_varID);

      function updateCustomSlider(variant_id) {
        $('.slick-prod-1 .mthumb').each(function () {
          var thumb_id = $(this).attr('data-media-id');
          //console.log(thumb_id);
          if ( thumb_id == variant_id ) {
            var slide_pos = $(this).parents('.slick-slide').attr('data-slick-index');

            $('.slick-prod-1').slick('slickGoTo', slide_pos );
          }
        })
      }

       $('.slider-mobile').on('click', '.cusclick', function () {
          $('.slider-mobile').slick('slickGoTo', $(this).attr('data-index'));
          $('.slick-prod-1').slick('slickGoTo', $(this).attr('data-index'));
      });


      // Check FBS and compare to actual price
      var checkExist = setInterval(function() {
        if (document.querySelector('#fsb_bar')) {
          clearInterval(checkExist);
          var getFBSamount = $('#fsb_bar').find('#fsb_amount').text();
          var getProdPrice = $('.price__regular').find('.price-item').data('price');
          if ( getProdPrice <=  getFBSamount) {
            $('.custom_product_wrap').find('.product__tax.normal-state').removeClass('d-none');
          } else {
            $('.custom_product_wrap').find('.product__tax.free-shipping-custom').removeClass('d-none');

          }
          //$('.custom_product_wrap').find('.b-desc .fs').text(getFBSamount);
          $('.custom_product_wrap').find('.b-desc .fs').text('24.99'); // temporary fix to 24.99 static
          $('.custom_product_wrap').find('.b-desc').removeClass('invisible');
        } else {
          var fbsBAR = document.getElementById("fsb_bar");

          if(fbsBAR) {
            $('.custom_product_wrap').find('.product__tax.normal-state').removeClass('d-none');
          }
        }
      });

      // setTimeout(() => {
      //   if (screen.width < 820 && document.querySelector('.template_product'))  {
      //     let product__title = document.querySelector('.product__title'),
      //     custom_slide = document.querySelector('.custom-slide');


      //     custom_slide.insertAdjacentElement('beforebegin', product__title);


      //     if (document.querySelector('.app_block_2')) {
      //       let reviews = document.querySelector('.app_block_2');
      //       custom_slide.insertAdjacentElement('beforebegin', reviews);
      //     }
      //   }
      // }, 1000);


